const PropertyType = {
  MANSION: "mansion",
  LAND: "land",
  HOUSE: "house",
} as const;

export const queryParamsPropertyTypeMapping = (propertyType: string | null) => {
  if (propertyType === "unit") {
    return PropertyType.MANSION;
  } else if (propertyType === PropertyType.HOUSE) {
    return PropertyType.HOUSE;
  } else if (propertyType === PropertyType.LAND) {
    return PropertyType.LAND;
  } else {
    return null;
  }
};

export type IPropertyType = typeof PropertyType[keyof typeof PropertyType];

export const toLabel = (type?: string) => {
  switch (type) {
    case PropertyType.MANSION:
      return "マンション";
    case PropertyType.HOUSE:
      return "戸建";
    case PropertyType.LAND:
      return "土地";
    default:
      return "";
  }
};

export const propertyTypeOptions = Object.values(PropertyType).map(value => ({
  label: toLabel(value),
  value,
}));

export const propertyTypeOptionsFromAreaInfo = (types: IPropertyType[]) => {
  if (types)
    return Object.values(types).map(value => ({
      label: toLabel(value),
      value,
    }));
};

export default PropertyType;
